import React from 'react'
import cn from 'classnames'

export interface IButton {
  onClick: React.MouseEventHandler<HTMLButtonElement> | undefined
  children?: string
  type?: 'primary' | 'ghost'
  className?: string
  iconLeft?: React.ReactNode
  iconRight?: React.ReactNode
}

const Button = ({ onClick, children, type = 'primary', className, iconLeft, iconRight }: IButton) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        'isst-button',
        {
          'isst-button--primary': type === 'primary',
          'isst-button--ghost': type === 'ghost'
        },
        className
      )}
    >
      {iconLeft && iconLeft}
      <h6
        className={cn({
          'isst-button__label--iconLeftSpacing': iconLeft,
          'isst-button__label--iconRightSpacing': iconRight
        })}
      >
        {children}
      </h6>
      {iconRight && iconRight}
    </button>
  )
}

export default Button
